const DEFAULT_TIMEZONE = 'America/Sao_Paulo';
let serverTimePromise = null;

const getTimeZone = (user) => user?.empresa_timezone || DEFAULT_TIMEZONE;

const formatUtcForDisplay = (value, user, locale = 'pt-BR') => {
  if (!value) return 'N/A';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return 'N/A';

  return new Intl.DateTimeFormat(locale, {
    timeZone: getTimeZone(user),
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
};

const formatUtcForDateTimeLocal = (value, user) => {
  if (!value) return '';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: getTimeZone(user),
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);

  const data = {};
  parts.forEach((part) => {
    if (part.type !== 'literal') {
      data[part.type] = part.value;
    }
  });

  return `${data.year}-${data.month}-${data.day}T${data.hour}:${data.minute}`;
};

const formatDateOnly = (value, user, locale = 'pt-BR') => {
  if (!value) return '-';

  const raw = String(value).slice(0, 10);
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return raw;

  const [, year, month, day] = match;
  if (locale === 'pt-BR') {
    return `${day}/${month}/${year}`;
  }

  return `${year}-${month}-${day}`;
};

const fetchServerTime = async (api) => {
  if (!serverTimePromise) {
    serverTimePromise = api.get('/system/time')
      .then((response) => response.data)
      .finally(() => {
        setTimeout(() => {
          serverTimePromise = null;
        }, 1000);
      });
  }

  return serverTimePromise;
};

export {
  DEFAULT_TIMEZONE,
  fetchServerTime,
  formatDateOnly,
  formatUtcForDateTimeLocal,
  formatUtcForDisplay,
  getTimeZone,
};
